/* eslint-disable no-undef */
import { useEffect, useState } from 'react';

const useCheckMobileScreen = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const handleWindowSizeChange = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return screenWidth <= 992;
};

export default useCheckMobileScreen;
